//dependencias
import React, { Component } from 'react';

//componentes
import ObservacionBPN from './observacionBPN'

class Index extends Component {

    render(){
        return(
            <div>
                <ObservacionBPN />
            </div>
        );
    }

}
export default Index;